import { render, staticRenderFns } from "./CheckinDataForm.vue?vue&type=template&id=67bcc7f4&scoped=true&"
import script from "./CheckinDataForm.vue?vue&type=script&lang=js&"
export * from "./CheckinDataForm.vue?vue&type=script&lang=js&"
import style0 from "./CheckinDataForm.vue?vue&type=style&index=0&id=67bcc7f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67bcc7f4",
  null
  
)

component.options.__file = "CheckinDataForm.vue"
export default component.exports